import React from 'react';
import { SvgIcon, makeStyles, createStyles } from '@material-ui/core';
import { TranquiTheme } from '../../containers/App/theme';

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  svg: {
    [theme.breakpoints.down('sm')]: {
      width: 301,
      height: 181,
    },
    [theme.breakpoints.up('sm')]: {
      width: 401,
      height: 281,
    },
  },
}));

const DeepLinkVerification: React.FC = () => {
  const classes = useStyles();
  return (
    <SvgIcon
      className={classes.svg}
      viewBox="0 0 400 299"
    >
      <path
        fill="#EBEBEB"
        d="M400 261.92H0v.2h400v-.2ZM359.922 274.793h-26.496v.2h26.496v-.2ZM323.351 274.793h-56.648v.2h56.648v-.2ZM235.465 267.367h-15.352v.2h15.352v-.2ZM69.4 268.711H41.97v.2H69.4v-.2ZM126.4 268.711H76.52v.2h49.88v-.2ZM180.112 272.088h-29.448v.2h29.448v-.2ZM189.598 226.24H35.126a4.566 4.566 0 0 1-4.56-4.568V4.528A4.568 4.568 0 0 1 35.126 0h154.472a4.566 4.566 0 0 1 4.568 4.568v217.104a4.576 4.576 0 0 1-1.338 3.23 4.558 4.558 0 0 1-3.23 1.338ZM35.126.16a4.368 4.368 0 0 0-4.36 4.368v217.144a4.369 4.369 0 0 0 4.36 4.368h154.472a4.382 4.382 0 0 0 4.368-4.368V4.528A4.38 4.38 0 0 0 189.598.16H35.126ZM362.65 226.24H208.17a4.583 4.583 0 0 1-4.568-4.568V4.528A4.573 4.573 0 0 1 208.17 0h154.48a4.568 4.568 0 0 1 4.552 4.528v217.144a4.567 4.567 0 0 1-1.33 3.227 4.564 4.564 0 0 1-3.222 1.341ZM208.17.16a4.382 4.382 0 0 0-4.368 4.368v217.144a4.38 4.38 0 0 0 4.368 4.368h154.48a4.386 4.386 0 0 0 4.368-4.368V4.528A4.386 4.386 0 0 0 362.65.16H208.17Z"
      />
      <path fill="#E6E6E6" d="M258.745 15.824H51.457v125.424h207.288V15.824Z" />
      <path fill="#F5F5F5" d="M257.343 15.824H48.223v125.424h209.12V15.824Z" />
      <path fill="#FAFAFA" d="M251.527 22.088H54.023v112.88h197.504V22.088Z" />
      <path
        fill="#fff"
        d="m235.904 134.968-42.52-112.872H175.48L218 134.968h17.904ZM212.926 134.968 170.398 22.096H158.07l42.528 112.872h12.328ZM137.801 134.968 95.273 22.096H82.945l42.52 112.872h12.336Z"
      />
      <path
        fill="#E6E6E6"
        d="M103.76 22.096h-6.928v112.88h6.928V22.096ZM213.369 22.096h-6.928v112.88h6.928V22.096Z"
      />
      <path
        fill="#F5F5F5"
        d="M102.506 17.432h-8.752v121.52h8.752V17.432ZM212.119 17.424h-8.752v121.52h8.752V17.424Z"
      />
      <path
        fill="#E6E6E6"
        d="M54.647 22.096h-.616v112.88h.616V22.096ZM265.031 7.752H45.807a.776.776 0 0 0-.776.776v.048c0 .429.348.776.776.776h219.224a.776.776 0 0 0 .776-.776v-.048a.776.776 0 0 0-.776-.776Z"
      />
      <path
        fill="#E6E6E6"
        d="M258.746 10.793a1.023 1.023 0 0 0 1.008-1.008V7.329a1.019 1.019 0 0 0-1.008-1.016 1.003 1.003 0 0 0-.933.62c-.05.123-.076.255-.075.388v2.456a1.006 1.006 0 0 0 .621.933c.123.05.255.076.387.074v.008ZM57.07 10.793a.999.999 0 0 0 1.008-1.008V7.327a1 1 0 0 0-1.713-.715c-.189.19-.295.447-.295.715v2.456a1.025 1.025 0 0 0 1 1.008Z"
      />
      <path
        fill="#EBEBEB"
        d="M255.032 8.55H46.016v89.497h209.016V8.55Z"
        opacity={0.6}
      />
      <path fill="#E0E0E0" d="M348.057 41.447h-52.912v54.104h52.912V41.447Z" />
      <path fill="#F5F5F5" d="M346.665 41.447h-54.712v54.104h54.712V41.447Z" />
      <path fill="#fff" d="M342.071 47.584h-45.544v41.824h45.544V47.584Z" />
      <path fill="#F0F0F0" d="M347.738 164.529H332.93v92.896h14.808v-92.896Z" />
      <path fill="#F0F0F0" d="M344.89 257.424H181.762v4.488H344.89v-4.488Z" />
      <path fill="#F5F5F5" d="M332.922 164.537h-154v92.896h154v-92.896Z" />
      <path fill="#E6E6E6" d="M347.738 160.617H332.93v3.92h14.808v-3.92Z" />
      <path fill="#F0F0F0" d="M332.922 160.617h-154v3.92h154v-3.92Z" />
      <path
        fill="#E0E0E0"
        d="M327.61 196.999H184.25v-24.2h143.36v24.2Zm-142.4-1h141.4v-22.248H185.242l-.032 22.248ZM327.61 249.199H184.25v-46.256h143.36v46.256Zm-142.4-.992h141.4v-44.248H185.242l-.032 44.248Z"
      />
      <path
        fill="#E0E0E0"
        d="M308.287 173.264H203.559v3.184h104.728v-3.184ZM308.287 203.439H203.559v3.184h104.728v-3.184ZM292.17 158.92h-56.912v1.696h56.912v-1.696ZM292.17 158.92h-56.912l5.472-32.584h56.912l-5.472 32.584Z"
      />
      <path
        fill="#EBEBEB"
        d="M291.111 158.92h-56.912l5.472-32.584h56.912l-5.472 32.584Z"
      />
      <path
        fill="#FAFAFA"
        d="m236.361 156.359 4.656-27.704a.722.722 0 0 1 .72-.608h52a.717.717 0 0 1 .673.436.723.723 0 0 1 .055.276.388.388 0 0 1 0 .136l-4.656 27.704a.718.718 0 0 1-.72.608h-52a.713.713 0 0 1-.728-.712.443.443 0 0 1 0-.136Z"
      />
      <path fill="#F0F0F0" d="M279.287 158.92h-56.912v1.696h56.912v-1.696Z" />
      <path
        fill="#E6E6E6"
        d="M135.255 150.303h-30.456c-6.864 0-13.056 5.944-14.672 14.088l-5.096 25.6H74.575c-4.984 0-9.272 4.264-10.208 10.168l-1.392 8.8c-2.104.36-3.912 2.296-4.424 4.864h62.88c6.856 0 13.04-5.936 14.656-14.072l7.312-36.8c1.288-6.624-2.6-12.648-8.144-12.648Zm-61.8 58.496h-7.736l1.296-8.04c.696-4.344 3.864-7.504 7.536-7.504h9.816l-1.168 6.248c-1.112 5.384-5.208 9.296-9.744 9.296Z"
      />
      <path
        fill="#E0E0E0"
        d="M120.113 213.752h2.208l4.184 48.168h-2.208l-4.184-48.168ZM111.824 213.752h2.208l4.184 48.168h-2.208l-4.184-48.168ZM68.134 213.752h-2.208l-4.184 48.168h2.208l4.184-48.168ZM76.423 213.752h-2.208l-4.184 48.168h2.208l4.184-48.168Z"
      />
      <path
        fill="#F5F5F5"
        d="M200.003 298.046c85.666 0 155.112-4.055 155.112-9.056 0-5.002-69.446-9.056-155.112-9.056s-155.112 4.054-155.112 9.056c0 5.001 69.446 9.056 155.112 9.056Z"
      />
      <path
        fill="#12D896"
        d="M295.61 18.8H104.394c-5.96 0-10.792 4.832-10.792 10.793v73.168c0 5.96 4.831 10.792 10.792 10.792H295.61c5.96 0 10.792-4.832 10.792-10.792V29.593c0-5.96-4.832-10.792-10.792-10.792Z"
      />
      <path
        fill="#fff"
        d="M295.61 18.8H104.394c-5.96 0-10.792 4.832-10.792 10.793v73.168c0 5.96 4.831 10.792 10.792 10.792H295.61c5.96 0 10.792-4.832 10.792-10.792V29.593c0-5.96-4.832-10.792-10.792-10.792Z"
        opacity={0.6}
      />
      <path
        fill="#fff"
        d="M295.612 21.201H104.396a8.392 8.392 0 0 0-8.392 8.392v73.168a8.392 8.392 0 0 0 8.392 8.392h191.216a8.392 8.392 0 0 0 8.392-8.392V29.593a8.392 8.392 0 0 0-8.392-8.392Z"
        opacity={0.9}
      />
      <path
        fill="#12D896"
        d="M295.612 21.201h-191.2a8.407 8.407 0 0 0-8.408 8.4v8.992h208v-8.992a8.417 8.417 0 0 0-8.392-8.4Z"
        opacity={0.7}
      />
      <path
        fill="#fff"
        d="M112.666 29.897a3.04 3.04 0 1 0-6.08 0 3.04 3.04 0 0 0 6.08 0ZM124.666 29.897a3.04 3.04 0 1 0-6.08 0 3.04 3.04 0 0 0 6.08 0ZM136.666 29.897a3.04 3.04 0 1 0-6.08 0 3.04 3.04 0 0 0 6.08 0Z"
      />
      <path
        fill="#12D896"
        d="M289.873 77.873H110.129a2.664 2.664 0 0 1-2.664-2.656 2.672 2.672 0 0 1 2.664-2.664h179.744a2.67 2.67 0 0 1 2.664 2.664 2.665 2.665 0 0 1-2.664 2.656Z"
        opacity={0.1}
      />
      <path
        fill="#12D896"
        d="M243.609 77.873h-133.48a2.664 2.664 0 0 1-2.664-2.656 2.672 2.672 0 0 1 2.664-2.664h133.48a2.662 2.662 0 0 1 1.878 4.542 2.656 2.656 0 0 1-1.878.778Z"
      />
      <path
        fill="#12D896"
        d="m199.752 106.975.8-3.368a1.004 1.004 0 0 0-.648-1.272.879.879 0 0 0-.352-.048h-12.168c-1.992-10.944-9.072-18.984-7.032-32.28 4-6.288-10.4-29.656-20.856-15.608-13.544.888-1.016 26.296-26.784 32.8-18.952 4.8-29.344 15.776-33.528 25.008a10.681 10.681 0 0 0 5.208 1.352h.48a35.847 35.847 0 0 1 6.584-9.88 86.25 86.25 0 0 0-3.656 9.88h93.128l.232-5.216a1.252 1.252 0 0 0-.288-.922 1.26 1.26 0 0 0-1.12-.446Z"
        opacity={0.1}
      />
      <path
        fill="#263238"
        d="M171.649 111.703c-1.6 12.16-3.408 36.144-36.696 38.52-21.984 1.56-31.624-19.336-45.464-26.152 1.224-9.984 5.808-20 5.968-20.4a38.873 38.873 0 0 0-9.552 18.84 31.918 31.918 0 0 0-4.928-1.4c0-9.408 9.96-27.424 35.736-33.92 25.776-6.496 13.24-31.904 26.784-32.8 10.472-14.048 24.856 9.32 20.856 15.608-2.576 16.808 9.416 25.2 7.296 41.704Z"
      />
      <path
        fill="#FFB573"
        d="M184.216 112.167a2.4 2.4 0 0 0-3.952-1.456l-4 3.392a2.41 2.41 0 0 0-.384 2.144l.712 2.328c1.876.12 3.756-.153 5.52-.8a3.59 3.59 0 0 0 2.4-4l-.296-1.608Z"
      />
      <path
        fill="#FFB573"
        d="M161.599 98.175c.16.88.376 1.96.584 2.96.208 1 .44 2.024.68 3.032.48 2.024 1.032 4 1.6 6 .568 2 1.288 3.872 2.024 5.744a47.16 47.16 0 0 0 2.584 5.24l-2.064-1.64c.427.273.941.375 1.44.288a7.588 7.588 0 0 0 2.648-.928 21.04 21.04 0 0 0 2.984-1.936c.984-.736 2-1.6 2.896-2.4l.192-.16a2.397 2.397 0 0 1 3.016-.09 2.404 2.404 0 0 1 .72 2.93 23.844 23.844 0 0 1-2.4 4 22.379 22.379 0 0 1-3.2 3.544 14.26 14.26 0 0 1-4.696 2.808 10.424 10.424 0 0 1-3.2.6 10.35 10.35 0 0 1-3.488-.512 3.76 3.76 0 0 1-1.888-1.4l-.176-.24a45.918 45.918 0 0 1-3.728-6.304 64.247 64.247 0 0 1-2.712-6.544 69.358 69.358 0 0 1-1.984-6.68c-.272-1.12-.536-2.248-.8-3.384-.264-1.136-.416-2.24-.592-3.52a4.8 4.8 0 0 1 9.472-1.52l.088.112Z"
      />
      <path
        fill="#12D896"
        d="M105.856 265.871c-1.24-5.6-.928-6.92-1.936-10a20.534 20.534 0 0 0-2.256-4.952c-.88-1.6.8-2.936 2.464-3.152 1.304-.16 2.68-.216 4.28-.472l3.456 6.448c-1.824 2.312-3.28 8-2.632 12.304.448 3.104-2.88 2.072-3.376-.176Z"
      />
      <path
        fill="#263238"
        d="M161.602 132.455s.912 47.416 1.88 73.688c2.544 15.544-50.912 47.912-50.912 47.912-1.144.544-4.176-5.384-4.128-6.76 0 0 22.992-33.864 36.688-42.04-15.2-41.96-11.04-72.8-11.04-72.8h27.512Z"
      />
      <path
        d="M134.057 132.455h17.352s-3.472 46.352-7.336 69.888c-13.944-40.464-10.016-69.888-10.016-69.888ZM123.33 227.199c6.584-8.216 14.2-16.8 20.32-20.992a745.277 745.277 0 0 0-2.456 28c-5.752 4.552-11.72 8.8-16.712 12.168a138.607 138.607 0 0 1-1.152-19.176Z"
        opacity={0.2}
      />
      <path
        fill="#12D896"
        d="M115.889 252.887c-.696.496-1.936 1.4-2.832 2.096a.68.68 0 0 1-.5.143.667.667 0 0 1-.452-.255 47.53 47.53 0 0 1-4.472-7.52.681.681 0 0 1 .136-.8l2.24-2.224a.695.695 0 0 1 .976 0l.072.088 5 7.504a.692.692 0 0 1-.168.968Z"
      />
      <path
        fill="#fff"
        d="M115.889 252.887c-.696.496-1.936 1.4-2.832 2.096a.68.68 0 0 1-.5.143.667.667 0 0 1-.452-.255 47.53 47.53 0 0 1-4.472-7.52.681.681 0 0 1 .136-.8l2.24-2.224a.695.695 0 0 1 .976 0l.072.088 5 7.504a.692.692 0 0 1-.168.968Z"
        opacity={0.3}
      />
      <path
        fill="#12D896"
        d="M141.655 292.991c-5.84 0-5.432-.088-8.728-.2-2.816-.104-3.464.248-5.728.2-1.888-.04-1.984-1.849-1.6-3.929.2-1.047.536-2.32.8-4h8.88a9.944 9.944 0 0 0 7.304 4.472c3.176.408 1.416 3.457-.928 3.457Z"
      />
      <path
        fill="#263238"
        d="M153.312 132.455s-9.184 50.56-12.552 73.48c-3.528 24.064-7.888 63.128-5.488 79.12-1.296.8-6.112.84-8.88 0 0 0-14.04-54.888-2.312-78.056-6.672-56.328 3.2-59.256 5.92-74.544h23.312Z"
      />
      <path
        fill="#12D896"
        d="M135.641 281.717c.122 1.11.325 2.209.608 3.288a.621.621 0 0 1-.034.491.609.609 0 0 1-.382.309.26.26 0 0 1-.088 0c-3.2.52-8-.232-9.496-.504a.793.793 0 0 1-.6-.56l-.76-3.08a.604.604 0 0 1 .028-.486.605.605 0 0 1 .372-.314c.071-.007.144-.007.216 0l9.408.176a.805.805 0 0 1 .728.68Z"
      />
      <path
        fill="#fff"
        d="M135.641 281.717c.122 1.11.325 2.209.608 3.288a.621.621 0 0 1-.034.491.609.609 0 0 1-.382.309.26.26 0 0 1-.088 0c-3.2.52-8-.232-9.496-.504a.793.793 0 0 1-.6-.56l-.76-3.08a.604.604 0 0 1 .028-.486.605.605 0 0 1 .372-.314c.071-.007.144-.007.216 0l9.408.176a.805.805 0 0 1 .728.68Z"
        opacity={0.3}
      />
      <path
        fill="#fff"
        d="M154.122 88.166c5.824 1.096 7.056 3.48 11.344 12.32-1.296 5.824-8.256 10.936-8.256 10.936s-12.696-15.736-3.088-23.256Z"
      />
      <path
        fill="#12D896"
        d="M129.999 132.455c-5.464 7.456-11.416 19.368-11.464 44.968 28.4 12.8 41.912 12.8 48.664 9.6-4.872-19.744-5.6-54.568-5.6-54.568-4.536-4.992-31.6 0-31.6 0Z"
      />
      <path
        d="M149.154 154.936c-2.488 9.2.064 18.4 2.256 20.44-1.504-5.312-2.256-20.44-2.256-20.44Z"
        opacity={0.2}
      />
      <path
        fill="#fff"
        d="M163.354 99.2c.096 3.104-.208 6.856-.904 14.248-.472 6.256 1.088 18.152-.88 19.024-4.976 1.392-18.04.752-31.568 0-.632-8.96-.4-15.136-6.064-35.136a7.351 7.351 0 0 1 4.704-9.272 7.248 7.248 0 0 1 1.6-.328 72.629 72.629 0 0 1 3.944-.304 99.592 99.592 0 0 1 14.328 0c1.56.144 3.2.336 4.72.552a11.879 11.879 0 0 1 10.12 11.216Z"
      />
      <path
        fill="#FFB573"
        d="M139.257 73.559c.8 4.712-1.304 10.824-4.304 13.896 0 0 4.368-.656 13.64 5.08 2.688-3.848.696-5.08.696-5.08-2.488-.48-2.488-2.296-1.512-5.8l-8.52-8.096Z"
      />
      <path
        fill="#12D896"
        d="M146.648 91.375c-3.056.432-4 5.048-4 5.048s-7.336-5.192-9.656-8.848c.923-.52 1.817-1.09 2.68-1.704 0 0 9.192 3.728 10.976 5.504ZM149.554 90.879s2.4.528 3.64 3.904c.696-6.728-2.488-7.344-2.488-7.344a3.544 3.544 0 0 0-2.8-.576c2.424 1.28 1.648 4.016 1.648 4.016Z"
      />
      <path
        d="m147.777 81.647-5-4.753c.088.8.224 1.8.408 2.768a10.5 10.5 0 0 0 4.08 6.152c-.24-.96 0-2.327.512-4.167Z"
        opacity={0.2}
      />
      <path
        fill="#FFB573"
        d="M141.193 62.742c-1.96 7.32-2.944 10.4-.656 15.424 3.44 7.608 12.592 8.8 16.624 2.36 3.64-5.832 6.232-16.8.376-22.352a9.698 9.698 0 0 0-9.516-2.527 9.706 9.706 0 0 0-6.828 7.095Z"
      />
      <path
        fill="#263238"
        d="M144.145 55.615c1.136 8.752 12.656 3.648 19.656 13.784-.664-8.64-9.144-20.904-19.656-13.784Z"
      />
      <path
        fill="#263238"
        d="M144.862 55.287c9.84 6.576-.928 11.904-8.2 11.512-2.4-7.264 8.2-11.512 8.2-11.512Z"
      />
      <path
        d="M149.833 68.247a3.806 3.806 0 0 0-2.528-1.448 7.73 7.73 0 0 0 2.528 1.448ZM149.45 68.798a3.142 3.142 0 0 0-2.544-.696c.79.409 1.657.646 2.544.696Z"
        opacity={0.2}
      />
      <path
        fill="#263238"
        d="M151.29 68.958c-.192.608-.04 1.224.336 1.368.376.144.84-.224 1.032-.8.192-.576.04-1.216-.336-1.368-.376-.152-.84.2-1.032.8ZM158.345 71.847c-.192.608-.04 1.216.336 1.368.376.152.8-.224 1.024-.8.224-.576.04-1.224-.336-1.368-.376-.144-.84.192-1.024.8Z"
      />
      <path fill="#263238" d="m159.199 70.982 1.511.12s-1.071.896-1.511-.12Z" />
      <path
        fill="#ED893E"
        d="M156.056 72.07c.066 1.588.335 3.16.8 4.68a2.528 2.528 0 0 1-2.184-.4l1.384-4.28Z"
      />
      <path
        fill="#263238"
        d="M150.691 77.296c.297.183.61.338.936.463a.157.157 0 0 0 .125.006.164.164 0 0 0 .091-.085.192.192 0 0 0-.112-.24 5.286 5.286 0 0 1-3.128-3.345.192.192 0 0 0-.216-.144.198.198 0 0 0-.108.092.196.196 0 0 0-.02.14 5.6 5.6 0 0 0 2.432 3.112Z"
      />
      <path
        fill="#FFB573"
        d="M137.603 67.616a5.248 5.248 0 0 0 1.6 3.888c1.352 1.176 2.904-.28 3.256-2.312.328-1.832 0-4.656-1.704-5.016-1.704-.36-3.152 1.488-3.152 3.44Z"
      />
      <path
        fill="#263238"
        d="M151.074 65a.344.344 0 0 0 .28-.048 2.745 2.745 0 0 1 2.568-.272.338.338 0 0 0 .264.02.34.34 0 0 0 .2-.172.408.408 0 0 0-.2-.504 3.407 3.407 0 0 0-3.248.312.383.383 0 0 0-.088.52.377.377 0 0 0 .224.144ZM161.731 69.367a.302.302 0 0 0 .264 0 .368.368 0 0 0 .184-.488 3.9 3.9 0 0 0-2.528-2.344.336.336 0 0 0-.4.256.403.403 0 0 0 .061.281.402.402 0 0 0 .235.167 3.152 3.152 0 0 1 1.984 1.88.397.397 0 0 0 .2.248ZM152.137 68.096l1.519.128s-1.072.855-1.519-.128Z"
      />
      <path
        fill="#FFB573"
        d="m128.647 99.704-2.4 4.96c-.8 1.672-1.6 3.352-2.328 5.024-.728 1.672-1.448 3.36-2.064 5.016a40.261 40.261 0 0 0-1.504 4.8l-.152-1.976c.069.341.211.663.416.944a9.432 9.432 0 0 0 1.144 1.488 34.826 34.826 0 0 0 3.2 3.136 79.418 79.418 0 0 0 3.68 3.064c1.28 1.008 2.592 2.008 3.848 2.984l.08.056a2.403 2.403 0 0 1 .679 3.055 2.403 2.403 0 0 1-2.919 1.129 50.783 50.783 0 0 1-4.888-1.96 51.585 51.585 0 0 1-4.696-2.456 34.283 34.283 0 0 1-4.568-3.2 19.987 19.987 0 0 1-2.224-2.208 10.923 10.923 0 0 1-2.016-3.416 3.608 3.608 0 0 1-.192-1.648v-.336a39.063 39.063 0 0 1 1.376-6.336c.568-2 1.248-3.896 1.976-5.776s1.52-3.704 2.344-5.512a71.855 71.855 0 0 1 2.712-5.368 4.802 4.802 0 0 1 8.757.825 4.802 4.802 0 0 1-.245 3.607l-.016.104Z"
      />
      <path
        fill="#fff"
        d="M129.935 87.783c-5.2 0-7.48 1.216-13.224 10.76 1.28 4.104 9.52 9.128 9.52 9.128s8.888-11.456 3.704-19.888Z"
      />
      <path
        fill="#FFB573"
        d="m138.615 135.566-.264-2.336a2.759 2.759 0 0 0-1.4-2.088l-3.624-2.008a5.091 5.091 0 0 0-4.68-.128l-.928.44c.184 3.912 3.256 8 3.256 8l.752 1.264a2.298 2.298 0 0 0 3.112.888l2.52-1.448a2.623 2.623 0 0 0 1.256-2.584Z"
      />
      <path
        fill="#12D896"
        d="M179.058 121.11h-27.424a1.01 1.01 0 0 1-.956-.585 1.001 1.001 0 0 1-.092-.383c0-.116.016-.232.048-.344l3.872-16.192a1.788 1.788 0 0 1 1.6-1.32h27.424a1.014 1.014 0 0 1 .725.267 1.007 1.007 0 0 1 .323.701.879.879 0 0 1-.048.352l-3.88 16.192a1.767 1.767 0 0 1-1.592 1.312Z"
      />
      <path
        fill="#fff"
        d="M151.735 119.806a.192.192 0 0 1-.126-.088.191.191 0 0 1-.028-.073.21.21 0 0 1 .002-.079l3.616-15.104a1.972 1.972 0 0 1 1.824-1.472h26.104a.2.2 0 0 1 .142.342.204.204 0 0 1-.142.058h-26.144a1.602 1.602 0 0 0-1.44 1.16l-3.608 15.104a.209.209 0 0 1-.074.11.21.21 0 0 1-.126.042Z"
      />
      <path
        fill="#FFB573"
        d="m183.304 107.086-.361.168a3.446 3.446 0 0 0-2.015 2.816l-.217 3.416a2.401 2.401 0 0 0 2.193 2.592h.479a1.605 1.605 0 0 0 1.505-1.504l.271-6.248a1.289 1.289 0 0 0-1.167-1.384 1.344 1.344 0 0 0-.688.144Z"
      />
      <path
        fill="#263238"
        d="M267.254 254.113c-2.624-11.728 2.616-39.864 4.8-46.232 2.184-6.368 17.344-13.984 26.544-18.104 9.2-4.12 26.048 7.096 26.048 7.096s-17.488-1.832-22.512.672c-5.024 2.504-15.736 10.176-19.2 16.752-3.464 6.576-15.12 26.056-15.68 39.816ZM235.312 208.889c12.04 1.264 21.912 9.496 25.048 12 3.136 2.504 4.384 12.576 4.848 18.584.464 6.008-9.208 13.288-9.208 13.288s4.56-9.472 4.16-12.8c-.4-3.328-2.568-10.896-5.6-14.2-3.032-3.304-9.599-11.984-19.248-16.872Z"
      />
      <path
        fill="#12D896"
        d="M263.918 246.504c1.128-16.432-6.728-27.256-5.6-40.264 1.128-13.008 15.784-42.032 17.056-50.24 2.4 7.264-8.168 42.2-7.704 51.672.464 9.472 5.448 28.584-3.752 38.832Z"
      />
      <path
        fill="#fff"
        d="M263.918 246.504c1.128-16.432-6.728-27.256-5.6-40.264 1.128-13.008 15.784-42.032 17.056-50.24 2.4 7.264-8.168 42.2-7.704 51.672.464 9.472 5.448 28.584-3.752 38.832Z"
        opacity={0.6}
      />
      <path
        fill="#12D896"
        d="M251.92 182.791a10.643 10.643 0 0 1 8.464 7.456 11.357 11.357 0 0 1-10.872 3.872c-5.344-.992-7.2-4-6.552-7.096.648-3.096 3.616-5.224 8.96-4.232ZM268.602 190.951a7.07 7.07 0 0 1-6.304 4 7.558 7.558 0 0 1-.488-7.64c1.6-3.2 3.856-3.88 5.728-2.888 1.872.992 2.672 3.296 1.064 6.528ZM264.983 218.704a7.065 7.065 0 0 1 1.816 7.264 7.55 7.55 0 0 1-7.4-1.992c-2.544-2.552-2.448-4.888-.904-6.344 1.544-1.456 3.944-1.488 6.488 1.072ZM271.407 233.712a4.37 4.37 0 0 1-4.592.584 4.648 4.648 0 0 1 .281-2.436 4.648 4.648 0 0 1 1.479-1.956c1.752-1.376 3.2-1.152 3.96-.096.76 1.056.624 2.528-1.128 3.904ZM276.4 210.895a9.865 9.865 0 0 1-10 3.128 10.527 10.527 0 0 1 2.152-10.472c3.344-3.752 6.608-3.808 8.8-1.784 2.192 2.024 2.392 5.392-.952 9.128Z"
      />
      <path
        fill="#263238"
        d="M264.601 247.048h-.08a.401.401 0 0 1-.32-.464c5.68-29.664.408-55.424-15.672-76.56a.409.409 0 0 1 .128-.656.396.396 0 0 1 .432.088v.04c16.224 21.328 21.552 47.296 15.832 77.2a.397.397 0 0 1-.32.352Z"
      />
      <path
        fill="#12D896"
        d="M250.4 160.801a12.387 12.387 0 0 1 1.496 13.048 13.246 13.246 0 0 1-12.416-5.144c-3.84-5.024-3.128-9.064-.12-11.248 3.008-2.184 7.184-1.696 11.04 3.344ZM247.235 247.087l-.88 12.577.799.056.879-12.577-.798-.056ZM245.973 264.064l-.375 5.36.8.056.375-5.36-.8-.056ZM285.073 238.264h-34.984l-3.616 50.76h42.224l-3.624-50.76Z"
      />
      <path
        fill="#12D896"
        d="M293.824 282.976a19.649 19.649 0 1 1 19.648-19.648 19.675 19.675 0 0 1-19.648 19.648Zm0-37.696a18.048 18.048 0 1 0 18.048 18.048 18.084 18.084 0 0 0-18.048-18.048Z"
      />
    </SvgIcon>
  );
};

export default DeepLinkVerification;
